export interface IDuplicateCategoryRequest {
    categoryId: string;
    duplicatedCategoryName: string | null;
    duplicatedColorName: string | null;
}

export class DuplicateCategoryRequest implements IDuplicateCategoryRequest {
    public categoryId: string;
    public duplicatedCategoryName: string | null;
    public duplicatedColorName: string | null;

    constructor(categoryId: string, duplicatedCategoryName: string | null, duplicatedColorName: string | null){
        this.categoryId = categoryId;
        this.duplicatedCategoryName = duplicatedCategoryName;
        this.duplicatedColorName = duplicatedColorName;
    }
}